/**
 * The ONLY browser seam of slice B (design.md AD1, Interfaces / Contracts):
 * triggers a client-side text-file download via `Blob` + `URL.createObjectURL`
 * + a programmatic `<a download>` click + `URL.revokeObjectURL`. No network
 * write, no persistence — spec `payroll-settlement-export`, "No Network
 * Write and Thin Browser Seam".
 *
 * Deliberately NOT unit-tested: jsdom does not implement
 * `URL.createObjectURL` (design.md Risk 5 / Testing Strategy), so this
 * function is never executed under Vitest. It is exercised only via
 * `vi.mock('../../js/infrastructure/browser-download.js')` in Unit B2's
 * wiring tests, and reviewed by inspection against this signature.
 *
 * @param {{filename: string, text: string, mime?: string}} params
 * @returns {void}
 */
export function downloadTextFile({ filename, text, mime = 'text/csv;charset=utf-8' }) {
    downloadBlob({ filename, blob: new Blob([text], { type: mime }) });
}

/**
 * Downloads a Blob the caller already has (the CSV via `downloadTextFile`,
 * the gift card PNG). Not unit-tested for the same reason (no
 * `createObjectURL` in jsdom); exercised in the real browser.
 *
 * @param {{filename: string, blob: Blob}} params
 * @returns {void}
 */
export function downloadBlob({ filename, blob }) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    // Review follow-up (Unit B2): revoking the object URL SYNCHRONOUSLY right
    // after `click()` has been observed to cancel the download in some
    // embedded/older browser engines, which resolve the Blob URL
    // asynchronously once the click is dispatched. Deferring the revoke by
    // one tick (`setTimeout(..., 0)`) lets the download actually start
    // before the URL is invalidated, while still freeing it promptly — the
    // anchor removal itself has no such race and stays synchronous.
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
